import { api } from "@/lib/api";

// Privacy-friendly store analytics: no cookies, no IP, no fingerprinting.
// The visitor id is a random token kept in their own browser's localStorage;
// it carries no identity and can be cleared anytime.
const SESSION_KEY = "ftr_asid";

export function analyticsSession() {
  let s = localStorage.getItem(SESSION_KEY);
  if (!s) {
    s = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, "");
    localStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

function deviceClass() {
  const w = window.innerWidth;
  return w < 640 ? "mobile" : w < 1024 ? "tablet" : "desktop";
}

// Fire-and-forget: analytics must never block or break shopping.
export function track(event, { slug, color } = {}) {
  if (!slug) return;
  try {
    api
      .post("/analytics/event", {
        event,
        slug,
        color: color || null,
        session: analyticsSession(),
        device: deviceClass(),
      })
      .catch(() => {});
  } catch {
    /* swallow */
  }
}
